var map = {
	"./BEstdeclaration.png": 269,
	"./DMspritev3.png": 270,
	"./LargerSimonsOpenBook.gif": 271,
	"./MeSpriteV3.png": 272,
	"./bananaLG.png": 273,
	"./basic-tiles.png": 274,
	"./charles-grimoire-inside.png": 275,
	"./charles-grimoire.png": 276,
	"./desertToadWizardMoving.gif": 277,
	"./dorimonLg.png": 278,
	"./dorumon.png": 279,
	"./ibrahim.png": 280,
	"./mikublink.gif": 281,
	"./pinkBatmanLG.png": 282,
	"./savsprite172.gif": 283,
	"./wall-in-progress.png": 284,
	"./waterbottle.png": 285,
	"./wikipixelia.png": 286
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 268;